__turbopack_context__.v({
  "compass": "VisualRootMobile-module-scss-module__H3ncMq__compass",
  "compass__icon": "VisualRootMobile-module-scss-module__H3ncMq__compass__icon",
  "compass__north": "VisualRootMobile-module-scss-module__H3ncMq__compass__north",
  "description": "VisualRootMobile-module-scss-module__H3ncMq__description",
  "image": "VisualRootMobile-module-scss-module__H3ncMq__image",
  "leftBlock": "VisualRootMobile-module-scss-module__H3ncMq__leftBlock",
  "listLink": "VisualRootMobile-module-scss-module__H3ncMq__listLink",
  "mask": "VisualRootMobile-module-scss-module__H3ncMq__mask",
  "mobTabActiveStyle": "VisualRootMobile-module-scss-module__H3ncMq__mobTabActiveStyle",
  "mobTabStyle": "VisualRootMobile-module-scss-module__H3ncMq__mobTabStyle",
  "queueBox": "VisualRootMobile-module-scss-module__H3ncMq__queueBox",
  "rightBlock": "VisualRootMobile-module-scss-module__H3ncMq__rightBlock",
  "rightBlock__tabs": "VisualRootMobile-module-scss-module__H3ncMq__rightBlock__tabs",
  "title": "VisualRootMobile-module-scss-module__H3ncMq__title",
  "wrapper": "VisualRootMobile-module-scss-module__H3ncMq__wrapper",
});
